import React from 'react';

const ThankYou = () => {
    const handleHomeClick = (e) => {
        e.preventDefault();
        window.history.pushState({}, '', '/');
        window.dispatchEvent(new PopStateEvent('popstate'));
    };

    return (
        <div className="bg-gray-50 py-8 sm:py-12 px-4 sm:px-6 lg:px-8 min-h-[calc(100vh-76px)] flex flex-col items-center justify-center w-full">
            <div className="max-w-xl w-full mx-auto bg-white rounded-3xl shadow-2xl p-6 sm:p-10 border border-gray-100 text-center relative overflow-hidden transform -translate-y-6 sm:-translate-y-10">
                {/* Background Accent Gradients */}
                <div className="absolute -top-24 -left-24 w-48 h-48 bg-blue-50 rounded-full blur-3xl opacity-50"></div>
                <div className="absolute -bottom-24 -right-24 w-48 h-48 bg-[#CD9830]/10 rounded-full blur-3xl opacity-50"></div>

                {/* Success Checkmark Icon */}
                <div className="relative z-10 mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-[#CD9830]/10 mb-8 border-2 border-[#CD9830]/20 animate-pulse">
                    <svg className="h-10 w-10 text-[#CD9830]" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                </div>

                {/* Text Details */}
                <div className="relative z-10 space-y-4">
                    <h1 className="text-3xl sm:text-4xl font-extrabold text-[#0A3D62] tracking-tight">
                        Thank You!
                    </h1>
                    <p className="text-lg font-semibold text-[#CD9830]">
                        Your Free Business Review Request Has Been Received
                    </p>
                    <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                        We've successfully received your request. One of our UAE tax and accounting specialists will review your information and contact you shortly to discuss your business requirements and recommend the most suitable solution.
                    </p>
                </div>

                {/* Action Button */}
                <div className="relative z-10 mt-8 pt-2 flex justify-center">
                    <a
                        href="/"
                        onClick={handleHomeClick}
                        className="inline-flex w-full sm:w-auto items-center justify-center px-8 py-3.5 border-2 border-transparent text-base font-bold rounded-xl text-white bg-[#0A3D62] hover:bg-[#06243A] transition-all duration-200 shadow-md hover:shadow-lg focus:outline-none"
                    >
                        Back to Homepage
                    </a>
                </div>

                {/* Urgent Contact Options */}
                <div className="relative z-10 mt-10 pt-6 border-t border-gray-100">
                    <p className="text-xs text-gray-400 font-medium mb-3">NEED IMMEDIATE ASSISTANCE?</p>
                    <div className="flex flex-col sm:flex-row justify-center items-center gap-4 text-sm font-semibold">
                        <a
                            href="https://wa.me/+971542119784?text=Hi!%20I%20just%20submitted%20a%20consultation%20form%20and%20need%20to%20speak%20with%20an%20expert%20urgently."
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center text-[#0A3D62] cursor-pointer"
                        >
                            <img src="/whatsapp-1.png" alt="WhatsApp" className="w-5 h-5 mr-2" />
                            <span>Chat on WhatsApp</span>
                        </a>
                        <span className="hidden sm:inline text-gray-300">|</span>
                        <a
                            href="tel:+971542119784"
                            className="flex items-center text-[#0A3D62] cursor-pointer"
                        >
                            <img src="/Phone.webp" alt="Phone" className="w-5 h-5 mr-2" />
                            <span>Call Us: +971 54 211 9784</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ThankYou;
